export default {
  showPassword: 'Zobrazit heslo',
};
